import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import {
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import Lineinput from '../../../../common/lineinput'
import * as mdt from '../../../../common/modaltypes'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import AddandRemoveBtn from './AddandRemoveBtn'
import { focusElemnt, navigation3 } from '../../../../common/helper'
import { deliveryTypeList, satusList } from '../../GSConstants'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const BookingHamaliModal = ({ data, updateModal, updateAlertError, updateBookingOperatorHamaliChargeInsertUpdate, getHamaliChrgListData, getBookingOperatorHamaliChargeList, reportData, updateBookingHamaliChargeInsertUpdate, getBookingChrgList }) => {
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const mapTranslated = (list = []) =>
    list.map((item) => ({ ...item, name: tr(item.translationKey, item.name) }))
  const { headText, isUpdate, ConsignmentTypeList, loginData, ChargeTypeList, HamaliTypeList, isEdit } = data
  const translatedStatusList = mapTranslated(satusList)
  const translatedChargeTypes = mapTranslated(ChargeTypeList)
  const translatedHamaliTypes = mapTranslated(HamaliTypeList)
  const activeStatus = () => translatedStatusList.find((item) => item.id === 1) || translatedStatusList[0]
  const inactiveStatus = () => translatedStatusList.find((item) => item.id === 0) || translatedStatusList[1]
  const [bookingChrg, setBookingChrg] = useState([])
  const [isActive, setIsActive] = useState(satusList[0])
  const [showData, setShowData] = useState(false)
  const [selConsignmentType, setSelConsignmentType] = useState('')
  const [selBookingType, setSelBookingType] = useState({ id: 1, name: 'Own Branch', translationKey: 'gsOwnBr' })
  const [chargeType, setChargeType] = useState(ChargeTypeList?.[0])
  const [hamaliType, setHamaliType] = useState(HamaliTypeList?.[0])
  const [successMessage, setSuccessMessage] = useState(false)

  useEffect(() => {
    focusElemnt('Consignment_Type')
  }, [])
  useEffect(() => {
    if (ConsignmentTypeList?.length > 0) {
      setSelConsignmentType(ConsignmentTypeList?.[0])
    }
  }, [ConsignmentTypeList])
  useEffect(() => {
    setIsActive((prev) => translatedStatusList.find((item) => item.id === prev?.id) || translatedStatusList[0])
    setChargeType((prev) => translatedChargeTypes.find((item) => item.id === prev?.id) || translatedChargeTypes[0] || prev)
    setHamaliType((prev) => translatedHamaliTypes.find((item) => item.id === prev?.id) || translatedHamaliTypes[0] || prev)
  }, [translations])
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const tableHeader = [
    { headerName: tr('gsRangeMin2', 'Range Min'), headerSx: { minWidth: '25%', textAlign: 'right' } },
    { headerName: tr('gsRangeMax2', 'Range Max'), headerSx: { minWidth: '25%', textAlign: 'right' } },
    { headerName: tr('gsHamaliChg2', 'Hamali Charge'), headerSx: { minWidth: '25%', textAlign: 'right' } },
    { headerName: tr('gsAction', 'Action'), headerSx: { minWidth: '25%', textAlign: 'left' } },
  ]
  const handleChangeBookingChrg = (event, field, index) => {
    let oldData = [...bookingChrg.map((val, i) => (i === index ? { ...val, [field]: event.target.value } : val))]
    if (field === 'NOPFrom') {
      oldData[index - 1].NOPUpto = event.target.value !== '' ? event.target.value - 1 : event.target.value
    }
    setBookingChrg(oldData)
  }
  const handleBookingChrg = (event, field, index) => {
    if (field === 'NOPUpto' && isUpdate && parseInt(event.target.value) > 99999) {
      updateAlertError({ show: true, msg: tr('gsToNopMax', 'To NOP value should not exceed 99999'), nextId: `NOPUpto-${index}` })
      resetBookingChrg(event, field, index)
    } else if (
      field === 'NOPUpto' &&
      isUpdate &&
      event.target.value !== '' &&
      (event.target.value !== '' ? parseInt(event.target.value) <= bookingChrg[index].NOPFrom : true)
    ) {
      updateAlertError({ show: true, msg: tr('gsToNopGt', 'To NOP value should greater than NOPFrom'), nextId: `NOPUpto-${index}` })
      resetBookingChrg(event, field, index)
    } else if (field === 'NOPFrom' && event.target.value !== '') {
      if (parseInt(event.target.value) <= bookingChrg[index - 1].NOPFrom) {
        updateAlertError({ show: true, msg: tr('gsGtPrev', 'Value must be greater than previous value'), nextId: `NOPFrom-${index}` })
        resetBookingChrg(event, field, index)
      } else if (
        bookingChrg.length - 1 > index
          ? bookingChrg[index + 1]?.NOPFrom !== ''
            ? parseInt(event.target.value) >= bookingChrg[index + 1]?.NOPFrom
            : false
          : false
      ) {
        updateAlertError({ show: true, msg: tr('gsLtNext', 'Value must be less than next value'), nextId: `NOPFrom-${index}` })
        resetBookingChrg(event, field, index)
      } else if (parseInt(event.target.value) >= 99999) {
        updateAlertError({ show: true, msg: tr('gsNopFromMax', 'NOPFrom should not exceed 99999'), nextId: `NOPFrom-${index}` })
        resetBookingChrg(event, field, index)
      } else if (
        isUpdate &&
        (index === 3 && bookingChrg[index].NOPUpto !== '' ? parseInt(event.target.value) > bookingChrg[index].NOPUpto : false)
      ) {
        updateAlertError({ show: true, msg: tr('gsLtToNop', 'Value must be less than TONOP value'), nextId: `NOPFrom-${index}` })
        resetBookingChrg(event, field, index)
      }
    }
  }
  const resetBookingChrg = (event, field, index) => {
    let oldData = [...bookingChrg.map((val, i) => (i === index ? { ...val, [field]: '' } : val))]
    if (field === 'NOPFrom') {
      oldData[index - 1].NOPUpto = ''
    }
    setBookingChrg(oldData)
  }
  const handleAddBookingChrg = (index) => {
    let newData = { NOPFrom: '', NOPUpto: bookingChrg[index].NOPUpto, bookingChrg: 0 }
    let newArr = [...bookingChrg.map((val, i) => (i === index ? { ...val, NOPUpto: '' } : val))]
    newArr.splice(index + 1, 0, newData)
    setBookingChrg(newArr)
    if (newArr.length===4) {
      setTimeout(()=>{
        focusElemnt( `removebtn-3`)
      },100)
    }
  }
  const handleRemoveBookingChrg = (index) => {
    let oldToNOP = bookingChrg[index].NOPUpto
    let newData = bookingChrg.filter((val, i) => i !== index)
    setBookingChrg([...newData.map((val, i) => (i === index - 1 ? { ...val, NOPUpto: oldToNOP } : val))])
    if (newData.length===3) {
      setTimeout(()=>{
        focusElemnt(`addBtn-2`)
      },100)
    }else{
      focusElemnt(`addBtn-${index-1}`)
    }
    
  }
  const hasEmptyValue = (array, properties) => {
    return array.some((obj) => {
      return properties.some((prop) => {
        const value = obj[prop]
        return value === '' || value == null
      })
    })
  }
  const resetAllChrg = () => {
    setShowData(false)
    setBookingChrg([])
    setIsActive(activeStatus())
  }
  const getBookingChrgValue = () => {
    resetAllChrg()
    if ((selConsignmentType === '' || selConsignmentType === ' ') && selBookingType?.id !== 2) {
      updateAlertError({ show: true, msg: tr('gsSelCnsErr', 'Please Select Consignment Type'), nextId: 'Consignment_Type' })
    } else {
      if (hamaliType.id === 0) {
        const body = {
          CompanyID: loginData?.intCompanyID,
          ConsignmentTypeID: selBookingType?.id === 2 ? 0 : selConsignmentType?.ConsignmentSubTypeID,
          BookingType: selBookingType?.id,
          ChargeType: chargeType?.id
        }
        getHamaliChrgListData(body)
          .then((res) => {
            if (res.status === 'Success') {
              let filterValue=reportData.filter((item)=>item.ConsignmentID==selConsignmentType?.ConsignmentSubTypeID && item.BookingTypeID==selBookingType?.id)
              if ((!isUpdate && res.Data.Table.length > 0 ) || (filterValue.length>0 && !isUpdate)) {
                updateAlertError({
                  show: true,
                  msg: tr('gsBkgChgExists', 'Booking Charge already updated for Selected Consignment Type'),
                  nextId: 'Consignment_Type',
                })
              } else {
                if (res.Data.Table.length > 0 && isUpdate) {
                  setShowData(true)
                  const updatedTable = res?.Data?.Table.map(val => ({ ...val, NOPFrom: val.RangeMin, NOPUpto: val.RangeMax, BookingType: val.DeliveryType, BookingUnitCharge: val.BookingHamaliCharge }));
                  setBookingChrg(updatedTable.sort((a, b) => a.NOPFrom - b.NOPFrom))
                  setIsActive(res.Data.Table[0]?.IsActive === 1 ? activeStatus() : inactiveStatus())
                } else {
                  setShowData(true)
                  setBookingChrg([{ NOPFrom: 1, NOPUpto: 99999, BookingUnitCharge: 0 }])
                  // setIsActive(activeStatus())
                }
              }
            } else {
              updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Consignment_Type' })
            }
          })
          .catch((err) => {
            console.log('Error:', err)
          })
      } else {
        const body = {
          CompanyID: loginData?.intCompanyID,
          ConsignmentTypeID: selBookingType?.id === 2 ? 0 : selConsignmentType?.ConsignmentSubTypeID,
          BookingType: selBookingType?.id,
          ChargeType: chargeType?.id
        }
        getBookingOperatorHamaliChargeList(body)
          .then((res) => {
            if (res.status === 'Success') {
              if (!isUpdate && res.Data.Table.length > 0) {
                updateAlertError({
                  show: true,
                  msg: tr('gsBkgChgExists', 'Booking Charge already updated for Selected Consignment Type'),
                  nextId: 'Consignment_Type',
                })
              } else {
                if (res.Data.Table.length > 0 && isUpdate) {
                  setShowData(true)
                  const updatedTable = res?.Data?.Table.map(val => ({ ...val, NOPFrom: val.RangeMin, NOPUpto: val.RangeMax, BookingType: val.DeliveryType, BookingUnitCharge: val.OptHamaliCharge }));
                  setBookingChrg(updatedTable.sort((a, b) => a.NOPFrom - b.NOPFrom))
                  setIsActive(res.Data.Table[0]?.IsActive === 1 ? activeStatus() : inactiveStatus())
                } else {
                  setShowData(true)
                  setBookingChrg([{ NOPFrom: 1, NOPUpto: 99999, BookingUnitCharge: 0 }])
                  setIsActive(inactiveStatus())
                }
              }
            } else {
              updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Consignment_Type' })
            }
          })
          .catch((err) => {
            console.log('Error:', err)
          })
      }
    }
  }
  const handleSaveAndUpdateChrg = () => {
    if (hamaliType.id === 0) {
      const body = {
        CompanyID: loginData?.intCompanyID,
        UserID: loginData?.intUserID,
        IsBookingHamaliCharge: selBookingType?.id === 1 ? 1 : 0,
        ConsignmentID: selBookingType?.id === 2 ? 0 : selConsignmentType?.ConsignmentSubTypeID,
        PayTypeQty: bookingChrg.map((val) => `${val.NOPFrom}-${val.NOPUpto}`).join(','),
        PayTypeCharge: bookingChrg.map((val) => val.BookingUnitCharge).join(','),
        IsActive: isActive?.id,
        ChargeTypeID: chargeType?.id
      }
      updateBookingHamaliChargeInsertUpdate(body)
        .then((res) => {
          if (res.status === 'Success') {
            resetAllChrg()
            setSuccessMessage(true)
            // updateModal(true, mdt.deliveryChrgConfModal)
          } else {
            updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
          }
        })
        .catch((err) => {
          console.log('Error:', err)
        })
    } else {
      const body = {
        CompanyID: loginData?.intCompanyID,
        UserID: loginData?.intUserID,
        IsOwnOptHamaliCharge: selBookingType?.id === 1 ? 1 : 0,
        ConsignmentID: selBookingType?.id === 2 ? 0 : selConsignmentType?.ConsignmentSubTypeID,
        PayTypeQty: bookingChrg.map((val) => `${val.NOPFrom}-${val.NOPUpto}`).join(','),
        PayTypeCharge: bookingChrg.map((val) => val.BookingUnitCharge).join(','),
        IsActive: isActive?.id,
        ChargeTypeID: chargeType?.id
      }
      updateBookingOperatorHamaliChargeInsertUpdate(body)
        .then((res) => {
          if (res.status === 'Success') {
            setSuccessMessage(true)
            resetAllChrg()
            // updateModal(true, mdt.deliveryChrgConfModal)
          } else {
            updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
          }
        })
        .catch((err) => {
          console.log('Error:', err)
        })
    }
  }
  const modalClose = () => {
    getBookingChrgList()
    updateModal(false, mdt.updateBookingChrgModal)
    setSuccessMessage(false)
    focusElemnt("LoadBtn")
  }
  return (
    <Modal
      headTxt={headText}
      width={successMessage ? '25%' : '50%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      {
        successMessage ?
          <>
            <Stack>
              <Box style={{ margin: '10px', fontSize: '17px' }}>
              {
                  isUpdate ?
                    <div> {tr('gsBkgHmlUpdOk', 'Booking Hamali Updated Successfully')}</div>
                    :
                    <div>{tr('gsBkgHmlCrtOk', 'Booking Hamali Created Successfully')}</div>
                }
              </Box>
            </Stack>
            <Stack>
              <div className="modal-btn-grp" style={{ marginRight: '10px' }}>
                <button
                  autoFocus
                  style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px' }}
                  onClick={() => modalClose()}
                >
                  {tr('gsOk', 'Ok')}
                </button>
              </div>
            </Stack>
          </>
          :
          <>
            <Stack className="GSConsTypeModal" style={{ padding: '16px' }}>
              <Grid container style={{ padding: '0px', justifyContent: 'space-between' }}>
                <Grid item xs={6} md={2.5}>
                  <DropDownOA
                    id={'Consignment_Type'}
                    label={tr('gsCnsType', 'Consignment Type')}
                    defaultvalue={selConsignmentType?.SubType || selConsignmentType}
                    data={ConsignmentTypeList || []}
                    idKey={`ConsignmentSubTypeID`}
                    dataKey={`SubType`}
                    onSelect={(val) => {
                      resetAllChrg()
                      setSelConsignmentType(val)
                      if (isEdit) {
                        const filteredData = reportData?.filter((item) => item?.ConsignmentID === val?.ConsignmentSubTypeID)
                        const deliveryTypeData = deliveryTypeList?.filter((val) => val.id == filteredData?.[0]?.BookingTypeID)
                        const chargeTypeData = translatedChargeTypes?.filter((val) => val.id == filteredData?.[0]?.ChargeTypeID)
                        setChargeType(chargeTypeData?.[0] || '')
                        setSelBookingType(deliveryTypeData?.[0] || '')
                      }
                    }}
                    width="100%"
                    nextId={'Booking_Type'}
                    prevId={hasEmptyValue(bookingChrg, ['NOPFrom', 'NOPUpto', 'BookingUnitCharge']) || !showData ? 'goBtn' : 'saveAndUpdateBtn'}
                    disabled={selBookingType?.id === 2}
                  />
                </Grid>
                <Grid item xs={6} md={2.5}>
                  <DropDownOA
                    id={'Booking_Type'}
                    label={tr('gsBookType', 'Booking Type')}
                    data={deliveryTypeList?.filter((obj) => obj.id !== 0)}
                    defaultvalue={selBookingType?.name || selBookingType}
                    onSelect={(val) => {
                      setSelBookingType(val)
                    }}
                    idKey={`id`}
                    dataKey={`name`}
                    width="100%"
                    prevId={`Consignment_Type`}
                    nextId={'Select_Charge_Type1'}
                  />
                </Grid>
                <Grid item xs={6} md={2.5}>
                  <DropDownOA
                    key={`charge-type-${language}-${chargeType?.name}`}
                    id={'Select_Charge_Type1'}
                    label={tr('gsChgType', 'Charge Type')}
                    defaultvalue={chargeType?.name}
                    data={translatedChargeTypes}
                    idKey={`id`}
                    dataKey={`name`}
                    width="100%"
                    prevId={`Booking_Type`}
                    nextId={'Select_Hamali_Type'}
                    onSelect={(val) => {
                      setChargeType(val)
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={2.5}>
                  <DropDownOA
                    key={`hamali-type-${language}-${hamaliType?.name}`}
                    id={'Select_Hamali_Type'}
                    label={tr('gsHamaliType', 'Hamali Type')}
                    defaultvalue={hamaliType?.name}
                    data={translatedHamaliTypes}
                    idKey={`id`}
                    dataKey={`name`}
                    width="100%"
                    prevId={`Select_Charge_Type1`}
                    nextId={'goBtn'}
                    onSelect={(val) => {
                      setHamaliType(val)
                    }}
                  />
                </Grid>
                <Grid item xs={6} md={1}>
                  <Button
                    variant="contained"
                    id={'goBtn'}
                    sx={{ paddingY: '6px !important' }}
                    onClick={() => {
                      getBookingChrgValue()
                    }}
                    className="btn btn-primary"
                    onKeyDown={(e) => navigation3(e, bookingChrg.length > 0 ? 'chrg-0' : 'Consignment_Type', 'Select_Hamali_Type', () => { })}
                  >
                    {tr('gsGo', 'Go')}
                  </Button>
                </Grid>
              </Grid>
            </Stack>
            <Box sx={{ display: 'flex', paddingX: '15px', marginBottom: '5px' }}>
              <TableContainer component={Paper} className="scroll" sx={{ marginBottom: '5px' }}>
                <Table
                  stickyHeader
                  size="small"
                  aria-label="a dense table"
                  sx={{
                    '& .MuiTableCell-root': {
                      padding: '6px 4px !important',
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {tableHeader.map((row, index) => {
                        return (
                          <TableCell
                            sx={{
                              ...row.headerSx,
                              backgroundColor: '#DAEDFE',
                              minHeight: '36px',
                              fontSize: '12px',
                              fontWeight: '600',
                              color: '#444',
                            }}
                          >
                            {row.headerName}
                          </TableCell>
                        )
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showData ? (
                      bookingChrg.map((row, index) => {
                        return (
                          <TableRow>
                            <TableCell>
                              <div className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput
                                  label={''}
                                  id={`NOPFrom-${index}`}
                                  disabled={index === 0}
                                  textAlign={'end'}
                                  value={row.NOPFrom}
                                  onChange={(e) => handleChangeBookingChrg(e, 'NOPFrom', index)}
                                  onBlur={(e) => handleBookingChrg(e, 'NOPFrom', index)}
                                  onKeyDown={(e) =>
                                    navigation3(e,
                                      isUpdate && index === 3 ? `NOPUpto-${index}` : `chrg-${index}`,
                                      bookingChrg.length >= 4 ? `chrg-${index - 1}` : `addBtn-${index-1}`,
                                      () => { }
                                    )
                                  }
                                />
                              </div>
                            </TableCell>
                            <TableCell>
                              <div className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput
                                  label={''}
                                  id={`NOPUpto-${index}`}
                                  disabled={isUpdate && index === 3 ? false : true}
                                  value={row.NOPUpto}
                                  textAlign={'end'}
                                  onChange={(e) => handleChangeBookingChrg(e, 'NOPUpto', index)}
                                  onBlur={(e) => handleBookingChrg(e, 'NOPUpto', index)}
                                  onKeyDown={(e) => navigation3(e, `chrg-${index}`, `NOPFrom-${index}`, () => { })}
                                />
                              </div>
                            </TableCell>
                            <TableCell>
                              <div className={'input--wrapper btmSpaceNotRequired'}>
                                <Lineinput
                                  label={''}
                                  id={`chrg-${index}`}
                                  value={row.BookingUnitCharge}
                                  textAlign={'end'}
                                  onChange={(e) => handleChangeBookingChrg(e, 'BookingUnitCharge', index)}
                                  onBlur={(e) => handleBookingChrg(e, 'BookingUnitCharge', index)}
                                  onKeyDown={(e) =>navigation3(e,bookingChrg.length >= 4? bookingChrg.length - 1 !== index ? `NOPFrom-${index + 1}`: `removebtn-${index}`: `addBtn-${index}`,isUpdate && index === 3 ? `NOPUpto-${index}` : index === 0 ? 'goBtn' : `NOPFrom-${index}`,() => { })}
                                />
                              </div>
                            </TableCell>
                            <TableCell>
                              <AddandRemoveBtn
                                addRow={handleAddBookingChrg}
                                removeRow={handleRemoveBookingChrg}
                                chargeType={chargeType}
                                index={index}
                                data={bookingChrg}
                                onKeyDownAdd={(e) =>navigation3(e,bookingChrg.length - 1 === index ? index === 0 ? 'status' : `removebtn-${index}`: `NOPFrom-${index + 1}`,`chrg-${index}`,() => { })}
                                onKeyDownRemove={(e) =>
                                  navigation3(e, 'status', bookingChrg.length >= 4 ? `chrg-${index}` : `addBtn-${index}`, () => {})
                                }
                              />
                            </TableCell>
                          </TableRow>
                        )
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4} align="center" sx={{ color: '#FE5200', minHeight: '36px', fontSize: '12px', fontWeight: '600' }}>
                          {tr('gsNoResult', 'No Result Found')}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Divider />
            <Box sx={{ display: 'flex', justifyContent: 'end', paddingX: '15px' }}>
              <Item>
                <DropDownOA
                  // sx={{ ...sx.itemsx, paddingX: '12px' }}
                  key={`status-${language}-${isActive?.name}`}
                  data={translatedStatusList}
                  id={'status'}
                  label={tr('gsStatus', 'Status')}
                  width="100%"
                  idKey={`id`}
                  dataKey={`name`}
                  defaultvalue={isActive?.name || []}
                  onSelect={(val) => {
                    setIsActive(val)
                  }}
                  nextId={'saveAndUpdateBtn'} 
                  prevId={`goBtn`}
                  isError={isActive.id == 0}
                  isSuccess={isActive.id == 1}
                //dropStyle={dropStyle}
                />
              </Item>
              <Item className="disabled-wrapper">
                <Button
                  variant="contained"
                  id={'saveAndUpdateBtn'}
                  disabled={hasEmptyValue(bookingChrg, ['NOPFrom', 'NOPUpto', 'BookingUnitCharge']) || !showData}
                  style={{ ...sx.fullHeight, ...sx.novp, padding: '6px 15px' }}
                  className="btn btn-primary"
                  onClick={handleSaveAndUpdateChrg}
                  onKeyDown={(e) => navigation3(e, 'Consignment_Type', 'status', () => { })}
                >
                  {isUpdate ? tr('gsUpdate', 'UPDATE') : tr('gsSave', 'SAVE')}
                </Button>
              </Item>
            </Box>
          </>
      }

    </Modal>
  )
}

export default BookingHamaliModal
